/**
 * API Token Management
 * Create, list, and revoke MCP API tokens
 */

import { apiFetch } from './config';

export interface ApiToken {
  company_id?: string | null;
  company_name?: string | null;
  scope?: string;
  token_plane?: 'well' | 'standard' | null;
  token_id: string;
  prefix: string;
  name: string;
  status: 'active' | 'revoked';
  last_used: string | null;
  request_count: number;
  created_at: string;
  revoked_at: string | null;
}

export interface CreatedToken {
  company_id?: string | null;
  company_name?: string | null;
  scope?: string;
  token_plane?: 'well' | 'standard' | null;
  token_id: string;
  token: string;
  token_prefix: string;
  name: string;
  message: string;
}

export const tokensApi = {
  list: async (): Promise<{ success: boolean; data?: ApiToken[]; error?: string }> => {
    const response = await apiFetch<any>('/api/user/api-tokens');
    if (response.success && response.data) {
      const tokens = response.data?.data?.tokens || response.data?.tokens || [];
      return { success: true, data: tokens };
    }
    return { success: false, error: response.error };
  },

  create: async (fields: { name: string; company_id?: string; scope: 'ro' | 'rw' }): Promise<{ success: boolean; data?: CreatedToken; error?: string }> => {
    const response = await apiFetch<any>('/api/user/api-tokens', {
      method: 'POST',
      body: JSON.stringify(fields),
    });
    if (response.success && response.data) {
      const token = response.data?.data || response.data;
      return { success: true, data: token };
    }
    return { success: false, error: response.error };
  },

  revoke: async (tokenId: string): Promise<{ success: boolean; error?: string }> => {
    const response = await apiFetch<any>(`/api/user/api-tokens?token_id=${encodeURIComponent(tokenId)}`, {
      method: 'DELETE',
    });
    return { success: response.success, error: response.error };
  },
};
